import axios from 'axios'

export default() => {
  return axios.create({
    baseURL: process.env.NODE_ENV === 'development' ? 'http://localhost:8081' : '',
    // withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/services/Api.js